import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { BrowserRouter } from 'react-router';
import { createRoot } from 'react-dom/client';
import { Providers } from '@/shared/Providers';
import { Booking, BookingProps } from '@/features/booking/app/Booking';
import { useLatestMount } from '@/features/booking/shared/model/latestActions';
import { ReactRouterBridge } from '@/features/booking/shared/model/urlState';

const ADD_REACT_QUERY_DEVTOOL =
    import.meta.env.VITE_ADD_REACT_QUERY_DEVTOOL === 'true';

export function BookingApp(containerQuery: string, bookingProps: BookingProps) {
    const elm = document.querySelector(containerQuery);
    const root = createRoot(elm);

    root.render(
        <Providers>
            <App {...bookingProps} />
            {ADD_REACT_QUERY_DEVTOOL && (
                <ReactQueryDevtools
                    initialIsOpen={false}
                    position="left"
                    buttonPosition="bottom-left"
                />
            )}
        </Providers>,
    );
}

function App(props: BookingProps) {
    useLatestMount();

    return (
        <BrowserRouter>
            <ReactRouterBridge />
            <Booking {...props} />
        </BrowserRouter>
    );
}
